import { render, staticRenderFns } from "./QueryHighlight.vue?vue&type=template&id=be3b90b4"
import script from "./QueryHighlight.vue?vue&type=script&lang=js"
export * from "./QueryHighlight.vue?vue&type=script&lang=js"
import style0 from "./QueryHighlight.vue?vue&type=style&index=0&id=be3b90b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports